import { Alert, Spinner } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { AddCalendarRates, useHotel } from "../../../Hotels"
import type { TSeasonFormInterval } from "../../../RateSheets"
import { useLocation, useParams } from "../../../router-utils"

export default function AddHotelRatesPage() {
	const { hotelId } = useParams("/hotels/:hotelId/add-rates")
	const { hotel, isFetching } = useHotel(hotelId)
	const { state } = useLocation()
	const intervals =
		(state as { intervals?: TSeasonFormInterval[] } | null)?.intervals || []

	return (
		<>
			<Helmet>
				<title>Add Rates | Hotel</title>
			</Helmet>
			<ForbidUnlessAuthorized anyPermissions={[PERMISSIONS.MANAGE_USERS]}>
				{isFetching && !hotel ? (
					<Spinner alignCenter padding="4" />
				) : !hotel ? (
					<Alert status="error">Hotel does not exist.</Alert>
				) : (
					<AddCalendarRates hotel={hotel} intervals={intervals} />
				)}
			</ForbidUnlessAuthorized>
		</>
	)
}
